import React, { useEffect, useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { Box, Flex, Text, Button, Image } from 'rebass';
import { useDispatch } from 'react-redux';
import { setCheckmark } from 'ui/actions';
import { useHistory } from 'react-router-dom';
import QuestionBar from 'stories/tell-a-story/QuestionBar';
import Firefly from './assets/Firefly.png';
import { FaArrowRight } from 'react-icons/fa';
import { ShareSocial } from 'react-share-social'

const sendEmailToEmailAddress = (url) => {
  const title = 'Tell a story';

  const body = `${url}`;
  return `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(
    body
  )}`;
};

function Span({ sx = {}, children, ...props }) {
  return (
    <Text
      sx={{
        fontSize: '18px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '120%',
        letterSpacing: '-0.396px',
        ...sx,
      }}
      {...props}
    >
      {children}
    </Text>
  );
}

function UpArrow() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="61" height="16" viewBox="0 0 61 16" fill="none">
      <path
        d="M0.5 14.5C0.223858 14.5 0 14.7239 0 15C0 15.2761 0.223858 15.5 0.5 15.5V14.5ZM57.5 15V15.5H58V15H57.5ZM57.5 0.5L54.6132 5.5H60.3868L57.5 0.5ZM0.5 15.5H57.5V14.5H0.5V15.5ZM58 15V5H57V15H58Z"
        fill="black"
      />
    </svg>
  );
}

const style = {
  root: {
    maxWidth: 500,
    width: '95vw',
    borderRadius: 3,
    padding: "0px 20px",
    border: 0,
  },
  iconContainer: {
    paddingTop: '0px'
  },
  copyContainer: {
    color: '#13C283',
    border: '2px dashed #342E57',
    borderRadius: '8px',
    background: '#fff',
    width: '100%',
  },
  copyUrl: {
    padding: 2,
    background: '#fff',
    border: 0,
    fontWeight: 700,
    width: ['calc(100vw - 168px)', '100%'],
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    borderRadius: '8px',
    color: '#13C283',
  },
  copyIcon: {
    color: '#13C283',
  },
  title: {
    color: 'aquamarine',
    fontStyle: 'italic',
    color: '#333',
  }
};

function CopyLink({ storyRequestData }) {
  const [supportShareApi, setSupportShareApi] = useState(false)
  const { replace } = useHistory()
  const dispatch = useDispatch()
  const publicVideoLink = storyRequestData?.['contributor-url'];

  const shareData = {
    title: publicVideoLink,
    text: publicVideoLink,
    url: publicVideoLink,
  }

  useEffect(() => {
    if (!navigator.canShare) {
      setSupportShareApi(false)
    } else if (navigator.canShare(shareData)) {
      setSupportShareApi(true)
    }
  }, [])

  return (
    <CopyToClipboard
      text={publicVideoLink}
      onCopy={() => {
        dispatch(setCheckmark({
          message: 'Link copied and is ready to paste into an email or text message',
          top: 100,
          height: '250px',
          width: '250px'
        }));
      }}

    >
      <Flex
        padding="16px 20px"
        width="max-content"
        justifyContent="center"
        alignItems="center"
        my={2}
        sx={{
          background: '#fff',
          cursor: 'pointer',
          borderRadius: '23px',
          border: '1.5px solid #9B59B6'
        }}
        onClick={() => {
          navigator.share(shareData)
            .then(() => dispatch(setCheckmark({
              message: 'Link shared successfully',
              top: 100,
              height: '200px',
              width: '200px'
            })))
            .catch((error) => console.error('Error sharing content:', error));
        }}
        height={40}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20" fill="none">
          <path d="M9 0H1C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1V13C0 13.2652 0.105357 13.5196 0.292893 13.7071C0.48043 13.8946 0.734784 14 1 14H6V16H8V14H6.001V12H8V10H6V12H2V2H8V6H10V1C10 0.734784 9.89464 0.48043 9.70711 0.292893C9.51957 0.105357 9.26522 0 9 0ZM6 7V8H8V6H7C6.73478 6 6.48043 6.10536 6.29289 6.29289C6.10536 6.48043 6 6.73478 6 7ZM10 20H12V18H10V20ZM10 8H12V6H10V8ZM6 19C6 19.2652 6.10536 19.5196 6.29289 19.7071C6.48043 19.8946 6.73478 20 7 20H8V18H6V19ZM15 6H14V8H16V7C16 6.73478 15.8946 6.48043 15.7071 6.29289C15.5196 6.10536 15.2652 6 15 6ZM14 20H15C15.2652 20 15.5196 19.8946 15.7071 19.7071C15.8946 19.5196 16 19.2652 16 19V18H14V20ZM14 12H16V10H14V12ZM14 16H16V14H14V16Z" fill="#9B59B6" />
        </svg>
        <Text ml={1} color="#9B59B6" fontSize="16px" fontWeight={500} lineHeight="150%" fontFamily="Poppins" letterSpacing="-0.32px">
          Sharing Link
        </Text>
      </Flex>
    </CopyToClipboard>
    // : <ShareSocial
    //   title="Share with your friends and family"
    //   url={publicVideoLink}
    //   socialTypes={['facebook', 'email', 'telegram', 'whatsapp']}
    //   style={style}
    //   onSocialButtonClicked={(e) => {
    //     if (e === 'email') {
    //       window.open(
    //         sendEmailToEmailAddress(publicVideoLink),
    //         '_blank'
    //       )
    //     }
    //   }}
    // />
  );
}

export default CopyLink;
